import { render, staticRenderFns } from "./ForfatterLoader.vue?vue&type=template&id=121376cd&"
import script from "./ForfatterLoader.vue?vue&type=script&lang=js&"
export * from "./ForfatterLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('121376cd', component.options)
    } else {
      api.reload('121376cd', component.options)
    }
    module.hot.accept("./ForfatterLoader.vue?vue&type=template&id=121376cd&", function () {
      api.rerender('121376cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/components/lf_forfatter/ForfatterLoader.vue"
export default component.exports